// extracted by mini-css-extract-plugin
module.exports = {"sendMessageForm":"InboxDetailsSendMessage_sendMessageForm__3EZEc","textAreaMessageForm":"InboxDetailsSendMessage_textAreaMessageForm__36GaD"};